import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class GuidService {

  constructor() { }

  /**
   * 生成唯一的 GUID
   * @returns {string} 返回一個新的 UUID v4 格式的字串
   */
  generateGuid(): string {
    return uuidv4();
  }
}
